module.exports = __webpack_public_path__ + "static/img/scene6.e695ed96.png";